var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-javascript" } }, [
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("this")]),
          _vm._v(".$dialog({\n  "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("title")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'Handle Error in Action'")
          ]),
          _vm._v(",\n  "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("component")]),
          _vm._v(": CatchError,\n  "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("accept")]),
          _vm._v(": {\n    callback() {\n      "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("return")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("new")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-built_in" } }, [
            _vm._v("Promise")
          ]),
          _vm._v("("),
          _c("span", { attrs: { class: "hljs-function" } }, [
            _vm._v("("),
            _c("span", { attrs: { class: "hljs-params" } }, [
              _vm._v("resolve, reject")
            ]),
            _vm._v(") =>")
          ]),
          _vm._v(" {\n        setTimeout("),
          _c("span", { attrs: { class: "hljs-function" } }, [
            _c("span", { attrs: { class: "hljs-params" } }, [_vm._v("()")]),
            _vm._v(" =>")
          ]),
          _vm._v(" {\n          reject({\n            "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("foo")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'bar'")]),
          _vm._v(",\n          })\n        }, "),
          _c("span", { attrs: { class: "hljs-number" } }, [_vm._v("3000")]),
          _vm._v(")\n      })\n    },\n  },\n})\n")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae36ab32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae36ab32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./src/Resource/Example/Action/ActionError.md
// module id = null
// module chunks = 